let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fDSlM")).then(() => parcelRequire('4uSeG'));